import { Command } from 'ckeditor5/src/core';
import { generateAccordionId, setAccordionState } from './utils';

export default class InsertAccordionCommand extends Command {
	execute() {
		const model = this.editor.model;
		const selection = model.document.selection;
		const selectedContent = model.getSelectedContent(selection);

		model.change((writer) => {
			const accordionWrapper = this._createAccordionWrapper(writer);
			const accordion = this._createAccordion(writer, accordionWrapper);
			const accordionTitle = this._createAccordionTitle(writer, accordion);
			const accordionContent = this._createAccordionContent(writer, accordion);

			// Insert paragraph if the selection is collapsed
			if (selection.isCollapsed) {
				writer.appendElement('paragraph', accordionContent);
			}

			model.insertContent(accordionWrapper);

			// If there is selected content, insert it into accordionContent
			if (!selection.isCollapsed) {
				writer.setSelection(accordionContent, 0);
				model.insertContent(selectedContent);
			}

			// Set the selection inside the accordion title
			writer.setSelection(accordionTitle, 'in');
		});
	}

	_createAccordionWrapper(writer) {
		return writer.createElement('accordionWrapper');
	}

	_createAccordion(writer, accordionWrapper) {
		const accordion = writer.createElement('accordion');
		const accordionId = generateAccordionId();
		writer.setAttribute('id', accordionId, accordion);
		setAccordionState(accordionId, true);
		writer.append(accordion, accordionWrapper);
		return accordion;
	}

	_createAccordionTitle(writer, accordion) {
		const accordionTitle = writer.createElement('accordionTitle');
		writer.append(accordionTitle, accordion);
		return accordionTitle;
	}

	_createAccordionContent(writer, accordion) {
		const accordionContent = writer.createElement('accordionContent');
		writer.append(accordionContent, accordion);
		return accordionContent;
	}

	refresh() {
		const model = this.editor.model;
		const selection = model.document.selection;
		const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'accordionWrapper');

		this.isEnabled = allowedIn !== null;
	}
}
